// Example placeholder values used only for the "Preview" toggle inside the
// Template Designer, so a shopkeeper can see roughly how a real label will
// look before any product is linked.
const SAMPLE_DATA_MAP = {
  product_name_en: "Nachani Ladoo",
  product_name_mr: "\u0928\u093E\u091A\u0923\u0940 \u0932\u093E\u0921\u0942",
  brand_en: "Sakhi's Special",
  brand_mr: "\u0938\u0916\u0940 \u0938\u094D\u092A\u0947\u0936\u0932",
  description_en: "Traditional homemade sweet",
  description_mr:
    "\u092A\u093E\u0930\u0902\u092A\u093E\u0930\u093F\u0915 \u0918\u0930\u0917\u0941\u0924\u0940 \u0917\u094B\u0921",
  category_en: "Sweets",
  category_mr: "\u0917\u094B\u0921",
  veg_type: "VEG",
  country_of_origin: "India",
  product_image: "",
  brand_logo: "",
  mrp: "150",
  selling_price: "140",
  discount: "10",
  gst: "5",
  hsn_code: "1704",
  weight: "250 g",
  pieces: "10",
  volume: "-",
  ingredients_en: "Ragi, Jaggery, Cardamom",
  ingredients_mr:
    "\u0928\u093E\u091A\u0923\u0940, \u0917\u0942\u0933, \u0935\u0947\u0932\u091A\u0940",
  manufacturer: "Sakhi Shop Pvt Ltd",
  address: "123 Market Road, Pune, Maharashtra",
  email: "support@sakhisshop.com",
  phone: "+91 9876543210",
  website: "www.sakhisshop.com",
  fssai: "12345678901234",
  storage_en: "Store in cool dry place.",
  storage_mr:
    "\u0925\u0902\u0921 \u0935 \u0915\u094B\u0930\u0921\u094D\u092F\u093E \u0920\u093F\u0915\u093E\u0923\u0940 \u0920\u0947\u0935\u093E.",
  batch: "B-2026-001",
  manufacturing_date: "01-07-2026",
  packed_date: "02-07-2026",
  expiry: "02-01-2027",
  best_before: "6 months",
  sku: "SKU-1001",
  barcode: "8901234567890",
  qr: "https://sakhisshop.com/product/1001",
  "nutrition.energy": "450",
  "nutrition.protein": "6",
  "nutrition.fat": "12",
  "nutrition.carbohydrates": "70",
  "nutrition.sugar": "35",
  "nutrition.fibre": "3",
  "nutrition.sodium": "10",
  "nutrition.iron": "2",
  "nutrition.calcium": "40",
};

export default SAMPLE_DATA_MAP;
